<li class="nav-item position-relative">
    <!-- Notification Icon with Click Handler -->
    <a class="nav-link" (click)="toggleNotificationDropdown($event)">
        <!-- Notification Icon SVG -->
        <div class="bill-wrapper position-relative">
            <div class="bill-icon">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 6.43994V9.76994" stroke="#767676" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" />
                    <path
                        d="M12.0199 2C8.3399 2 5.3599 4.98 5.3599 8.66V10.76C5.3599 11.44 5.0799 12.46 4.7299 13.04L3.4599 15.16C2.6799 16.47 3.2199 17.93 4.6599 18.41C9.4399 20 14.6099 20 19.3899 18.41C20.7399 17.96 21.3199 16.38 20.5899 15.16L19.3199 13.04C18.9699 12.46 18.6899 11.43 18.6899 10.76V8.66C18.6799 5 15.6799 2 12.0199 2Z" stroke="#767676" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" />
                    <path
                        d="M15.3299 18.8198C15.3299 20.6498 13.8299 22.1498 11.9999 22.1498C11.0899 22.1498 10.2499 21.7698 9.64992 21.1698C9.04992 20.5698 8.66992 19.7298 8.66992 18.8198" stroke="#767676" stroke-width="1.5" stroke-miterlimit="10" />
                </svg>
                <!-- Bill icon -->
                <span *ngIf="notifications && notifications.length > 0" class="notification-badge">{{ notifications.length || 0 }}</span>
                <!-- Notification badge -->
            </div>
        </div>
    </a>

    <div *ngIf="isDropdownOpen" class="notification-dropdown notificationfeed position-absolute">
        <!-- Feed Header -->
        <div class="feedheader">
            <div class="notifications-parent">
                <div class="notifications feedheader">Notifications</div>
                <!-- Clear All Button -->
                <div class="clear-all ml-auto">
                    <button (click)="clearAllNotifications()" *ngIf="notifications.length > 0">Clear All</button>
                </div>
            </div>
        </div>

        <!-- Notifications Feed -->
        <div class="feeditems">
            <!-- If notifications exist, display them -->
            <div *ngIf="notifications.length > 0; else noNotifications">
                <div *ngFor="let notification of notifications; let i = index" class="notificationcell">


                    <div class="isreadindicator">
                        <div class="isreadindicator-child" ngClass="{ 'unread': !notification.isRead }"></div>
                    </div>
                    <div class="content">
                        <div class="avatarandsubjectcontainer">
                            <div class="icon-container">
                                <img src="../../assets/icons/NotificationsIcons/system1.png" alt="notification icon" class="icon-image" />
                            </div>
                            <div class="subjectlinecontainer">
                                <div class="dennis-nedry-commented">
                                    {{ notification.subject }}
                                </div>
                            </div>
                            <div class="spacer"></div>
                            <!-- Clear Individual Notification Button -->
                            <div class="clear-button">
                                <button (click)="clearNotification(i,notification.id)">Clear</button>
                            </div>
                        </div>
                        <div class="systemandsubjectcontainer">
                            <div class="new-account-created-container">
                                <span class="new-tenders">{{ notification.message }}</span>
                            </div>
                        </div>
                        <div class="timestampcontainer">
                            <div class="text">{{ notification.formattedTimestamp }}</div>
                        </div>
                    </div>
                    <div class="divider"></div>
                </div>
            </div>

            <!-- Template for no notifications -->
            <ng-template #noNotifications>
                <div class="content no-notifications-card">
                    <div class="no-notifications-message">
                        <p>No notifications available</p>
                    </div>
                </div>
            </ng-template>
        </div>
    </div>
</li>